import React from 'react';
import { Link } from 'react-router-dom';

// Material UI
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

const LinkButton = ({path, title, text, Icon, start}) => {
    return(
        <Tooltip title={title}>
            <Button 
                startIcon={!!start && <Icon /> }
                endIcon={!start && <Icon /> }
                variant='outlined'
                color='primary'
                component={Link} 
                to={path} 
            >
                {text}
            </Button>
        </Tooltip>
    )
}

export default LinkButton